var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgThumbsUpFilled = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.629 8.717c.322 0 .62.094.871.257V19.74c-.25.163-.548.26-.871.26H4.622C3.718 20 3 19.255 3 18.356V10.36c0-.898.718-1.642 1.622-1.642zm4.6-3.785A2.32 2.32 0 0 1 14.9 4.87c.355.438.547.987.547 1.55v3.04h2.79c.81 0 1.561.413 2.007 1.09l.35.533c.345.524.475 1.16.37 1.772l-.058.261-1.444 5.111A2.42 2.42 0 0 1 17.144 20H10.46a2.4 2.4 0 0 1-1.77-.784l-.191-.21V8.553z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgThumbsUpFilled);
export default ForwardRef;